import { useEffect, useRef, useState } from "react"
import { IS_CAPTCHA_ENABLED, RECAPTCHA_V2_SITE_KEY } from "@/constants/allconstants";

const isValidSiteKey = (key) => typeof key === 'string' && key.startsWith('6L');

export const ReCaptchaV2 = ({setToken}) => {
    const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
    const captchaRef = useRef(null);
    const onLoadRecaptcha = () => {
        setRecaptchaLoaded(true);
    }

    useEffect(() => {
        window.onLoadRecaptcha = onLoadRecaptcha;
        if (!window.grecaptcha) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onLoadRecaptcha&render=explicit';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }else if (window.grecaptcha && window.grecaptcha.render) {
            setRecaptchaLoaded(true);   
        }
        return () => {
            window.onLoadRecaptcha = null;
        }
    }, []);

    useEffect(() => {
        if (!IS_CAPTCHA_ENABLED || !isValidSiteKey(RECAPTCHA_V2_SITE_KEY)) {
            return;
        }
        if (recaptchaLoaded) {
            window.grecaptcha.render(captchaRef.current, {
                sitekey: RECAPTCHA_V2_SITE_KEY,
                callback: (token) => setToken(token),
                "expired-callback": () => setToken('')
            });
        }
    }, [recaptchaLoaded]);
    if (!IS_CAPTCHA_ENABLED || !isValidSiteKey(RECAPTCHA_V2_SITE_KEY)) {
        return null;
    }
    return (
        <div ref={captchaRef}></div>
    )
}